// Local stub for the Inventory StoreService.
// HRMS does not ship the Inventory module, so these methods short-circuit to
// empty results instead of calling a non-existent inventory backend.
class StoreServiceStub {
  getBranch(_organizationId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
  getUser(_dataModel: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
  getStoreList(_organizationId: any, _branchId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
  getStoreListByUserId(_userId: any, _organizationId: any, _isAdmin: any, _branchId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
  StoreDropDownListByUserId(_userId: any, _organizationId: any, _isAdmin: any, _branchId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
}
export default new StoreServiceStub();
